// ListingService.jsx

import listingsData from '../data/listings.json';

// Existing code to fetch all listings
export const fetchListings = () => {
    return listingsData;
};

// Existing code to fetch a single listing by ID
export const fetchListingById = (id) => {
    return listingsData.find((item) => item.id === parseInt(id));
};

// Additional code to simulate in-memory listings for deletions and agent-specific listings
let inMemoryListings = [...listingsData];

// New function: Fetch listings for a specific agent by agent ID
export const fetchAgentListings = (agentId) => {
    // Assuming each listing in the JSON data has an `agentId` field to identify the agent
    return inMemoryListings.filter((listing) => listing.agentId === agentId);
};

// New function: Delete a listing by ID
export const deleteListingById = (id) => {
    inMemoryListings = inMemoryListings.filter((listing) => listing.id !== parseInt(id));
    return inMemoryListings; // Return updated listings for convenience
};


// Function update a listing by ID 
export const updateListing = (updatedListing) => {
    const index = inMemoryListings.findIndex((listing) => listing.id === updatedListing.id);
    if (index !== -1) {
      inMemoryListings[index] = updatedListing;
    }
  };


  